'use client'
import { useState, useEffect } from 'react'
import { useAuth } from '@/context/AuthContext'

export default function FooterReferral() {
  const { currentUser, accessToken } = useAuth()
  const [copied, setCopied] = useState(false)
  const [stats, setStats] = useState(null)

  const refCode = currentUser ? currentUser.uid.replace(/-/g, '').slice(0, 8).toLowerCase() : null
  const refLink = refCode ? `https://fairfares.app/?ref=${refCode}` : null

  useEffect(() => {
    if (!refCode) return
    fetch(`/api/referral?code=${refCode}`)
      .then(r => r.json())
      .then(d => setStats(d))
      .catch(() => {})
  }, [refCode])

  async function handleCopy() {
    if (!refLink) return
    try { await navigator.clipboard.writeText(refLink) } catch {}
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="border-t border-slate-800 pt-6 pb-4">
      <div className="flex flex-wrap items-start gap-4">
        <div className="shrink-0">
          <p className="text-gray-300 text-xs font-semibold uppercase tracking-wider mb-1">🎁 Refer &amp; earn</p>
          <p className="text-xs text-gray-500 max-w-xs">
            Friend completes onboarding → <span className="text-gray-400 font-medium">they get a free Plus month</span>. Friend pays → <span className="text-gray-400 font-medium">you earn a month</span>.{' '}
            <a href="/faq#refer" className="text-blue-400 hover:text-blue-300 underline">Details →</a>
          </p>
        </div>

        {currentUser && refLink ? (
          <div className="flex items-center gap-2 min-w-0">
            <span className="text-xs font-mono text-gray-400 bg-slate-800 rounded px-2 py-1.5 truncate max-w-[200px]">
              {refLink}
            </span>
            <button
              onClick={handleCopy}
              className="shrink-0 text-xs font-semibold bg-slate-700 hover:bg-slate-600 text-gray-200 rounded px-3 py-1.5 transition-colors"
            >
              {copied ? '✓ Copied' : 'Copy'}
            </button>
            {stats && (stats.earned > 0 || stats.pending > 0) && (
              <span className="shrink-0 text-xs text-gray-500">
                {stats.earned > 0 && `${stats.earned} month${stats.earned !== 1 ? 's' : ''} earned`}
                {stats.earned > 0 && stats.pending > 0 && ' · '}
                {stats.pending > 0 && `${stats.pending} pending`}
              </span>
            )}
          </div>
        ) : (
          <a href="/deals" className="text-xs text-blue-400 hover:text-blue-300 underline self-center">
            Sign in to get your link →
          </a>
        )}
      </div>
    </div>
  )
}
